import nodeFetch from 'node-fetch'
const isNode = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
if (isNode && !global.fetch) {
  global.fetch = function (url, options) {
    if (/^\/\//.test(url)) {
      url = 'https:' + url
    }
    return nodeFetch.call(this, url, options)
  }
  global.Response = nodeFetch.Response
  global.Headers = nodeFetch.Headers
  global.Request = nodeFetch.Request
}



// WEBPACK FOOTER //
// ../src/lib/fetchPolyfill.js